module.exports = __webpack_public_path__ + "img/dcms.c1665788.png";